import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '@/views/Index'

import Auth from '@/views/Auth'
import Login from '@/views/auth/Login'

import FrontDesk from '@/views/FrontDesk'
import FrontDeskDashboard from '@/views/front-desk/Dashboard'
import FrontDeskShippingTestFirst from '@/views/front-desk/shipping-test/First'
import FrontDeskShippingTestSecond from '@/views/front-desk/shipping-test/Second'
import FrontDeskShippingTestThird from '@/views/front-desk/shipping-test/Third'
import FrontDeskSearch from '@/views/front-desk/Search'
import EditFrontDeskShippingTestFirst from '@/views/front-desk/shipping-test/edit/First'
import EditFrontDeskShippingTestSecond from '@/views/front-desk/shipping-test/edit/Second'
import EditFrontDeskShippingTestThird from '@/views/front-desk/shipping-test/edit/Third'
import FrontDeskTouristTestFirst from '@/views/front-desk/tourist-test/First'
import FrontDeskTouristTestSecond from '@/views/front-desk/tourist-test/Second'
import FrontDeskTouristTestThird from '@/views/front-desk/tourist-test/Third'
import EditFrontDeskTouristTestFirst from '@/views/front-desk/tourist-test/edit/First'
import EditFrontDeskTouristTestSecond from '@/views/front-desk/tourist-test/edit/Second'
import EditFrontDeskTouristTestThird from '@/views/front-desk/tourist-test/edit/Third'
import frontDeskCellexTestFirst from '@/views/front-desk/cellex-text/First'
import frontDeskCellexTestSecond from '@/views/front-desk/cellex-text/Second'
import frontDeskCellexTestThird from '@/views/front-desk/cellex-text/Third'
import frontDeskCellexTestFourth from '@/views/front-desk/cellex-text/Fourth'


import SelfService from '@/views/SelfService'
import SelfServiceDashboard from '@/views/self-service/Dashboard'
import SelfServiceShippingTestFirst from '@/views/self-service/shipping-test/First'
import SelfServiceShippingTestSecond from '@/views/self-service/shipping-test/Second'
import SelfServiceTouristTestFirst from '@/views/self-service/tourist-test/First'
import SelfServiceTouristTestSecond from '@/views/self-service/tourist-test/Second'



import Company from '@/views/Company'
import CompanyDashboard from '@/views/company/Dashboard'
import CompanySearch from '@/views/company/Search'

import Admin from '@/views/Admin'
import AdminDashboard from '@/views/admin/Dashboard'
import AdminNewCompany from '@/views/admin/NewCompany'

import EmailCase from '@/views/EmailCase'


import SelfServiceCellexTestFirst from '@/views/self-service/cellex-test/First'
import SelfServiceCellexTestThird from '@/views/self-service/cellex-test/Third'

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

const routes = [
  {
    name: 'caseDetails',
    path: '/case/:caseCode',
    component: EmailCase
  },
  {
    name:'index',
    path: '/',
    component: Index
  },
  {
    name: 'auth',
    path: '/auth',
    component: Auth,
    children: [
      {
        name: 'login',
        path: 'login',
        component: Login
      }
    ]
  },
  {
    name: 'frontDesk',
    path: '/frontDesk',
    component: FrontDesk,
    children: [
      {
        name: 'frontDeskDashboard',
        path: 'dashboard',
        component: FrontDeskDashboard
      },
      {
        name: 'frontDeskSearch',
        path: 'search',
        component: FrontDeskSearch
      },
      {
        name: 'frontDeskShippingTestFirst',
        path: 'shippingTest/first',
        component: FrontDeskShippingTestFirst
      },
      {
        name: 'frontDeskShippingTestSecond',
        path: 'shippingTest/second',
        component: FrontDeskShippingTestSecond
      },
      {
        name: 'frontDeskShippingTestThird',
        path: 'shippingTest/third',
        component: FrontDeskShippingTestThird
      },
      {
        name: 'editFrontDeskShippingTestFirst',
        path: 'shippingTest/edit/first',
        component: EditFrontDeskShippingTestFirst
      },
      {
        name: 'editFrontDeskShippingTestSecond',
        path: 'shippingTest/edit/second',
        component: EditFrontDeskShippingTestSecond
      },
      {
        name: 'editFrontDeskShippingTestThird',
        path: 'shippingTest/edit/third',
        component: EditFrontDeskShippingTestThird
      },
      {
        name: 'frontDeskTouristTestFirst',
        path: 'touristTest/first',
        component: FrontDeskTouristTestFirst
      },
      {
        name: 'frontDeskTouristTestSecond',
        path: 'touristTest/second',
        component: FrontDeskTouristTestSecond
      },
      {
        name: 'frontDeskTouristTestThird',
        path: 'touristTest/third',
        component: FrontDeskTouristTestThird
      },
      {
        name: 'editFrontDeskTouristTestFirst',
        path: 'touristTest/edit/first',
        component: EditFrontDeskTouristTestFirst
      },
      {
        name: 'editFrontDeskTouristTestSecond',
        path: 'touristTest/edit/second',
        component: EditFrontDeskTouristTestSecond
      },
      {
        name: 'editFrontDeskTouristTestThird',
        path: 'touristTest/edit/third',
        component: EditFrontDeskTouristTestThird
      },
      {
        name: 'frontDeskCellexTestFirst',
        path: 'cellexTest/first',
        component: frontDeskCellexTestFirst
      },
      {
        name: 'frontDeskCellexTestSecond',
        path: 'cellexTest/second',
        component: frontDeskCellexTestSecond
      },
      {
        name: 'frontDeskCellexTestThird',
        path: 'cellexTest/third',
        component: frontDeskCellexTestThird
      },
      {
        name: 'frontDeskCellexTestFourth',
        path: 'cellexTest/fourth',
        component: frontDeskCellexTestFourth
      }
    ]
  },
  {
    name: 'selfService',
    path: '/selfService',
    component: SelfService,
    children: [
      {
        name: 'selfServiceDashboard',
        path: 'dashboard',
        component: SelfServiceDashboard
      },
      {
        name: 'selfServiceShippingTestFirst',
        path: 'shippingTest/first',
        component: SelfServiceShippingTestFirst
      },
      {
        name: 'selfServiceShippingTestSecond',
        path: 'shippingTest/second',
        component: SelfServiceShippingTestSecond
      },
      {
        name: 'selfServiceTouristTestFirst',
        path: 'touristTest/first',
        component: SelfServiceTouristTestFirst
      },
      {
        name: 'selfServiceTouristTestSecond',
        path: 'touristTest/second',
        component: SelfServiceTouristTestSecond
      },
      {
        name: 'selfServiceCellexTestFirst',
        path: 'cellexTest/first',
        component: SelfServiceCellexTestFirst
      },
      {
        name: 'selfServiceCellexTestThird',
        path: 'cellexTest/third',
        component: SelfServiceCellexTestThird
      }
    ]
  },
  {
    name: 'company',
    path: '/company',
    component: Company,
    children: [
      {
        name: 'companyDashboard',
        path: 'dashboard',
        component: CompanyDashboard
      },
      {
        name: 'companySearch',
        path: 'search',
        component: CompanySearch
      }
    ]

  },
  {
    name: 'admin',
    path: '/admin',
    component: Admin,
    children: [
      {
        name: 'adminDashboard',
        path: 'dashboard',
        component: AdminDashboard
      },
      {
        name: 'adminNewCompany',
        path: 'newCompany',
        component: AdminNewCompany

      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
